// Mobile-only sticky buy bar — appears once the main Add to Cart button has
// scrolled up out of view; hides again when it's back on screen.
import { useEffect, useState } from 'react';

export default function StickyAddToCart({ targetRef, priceStr, variantTitle, label, onClick, disabled, busy }) {
        const [show, setShow] = useState(false);

        useEffect(() => {
                const el = targetRef.current;
                if (!el) return undefined;
                let raf = 0;
                const check = () => {
                        raf = 0;
                        setShow(el.getBoundingClientRect().bottom < 0);
                };
                const onScroll = () => { if (!raf) raf = requestAnimationFrame(check); };
                check();
                window.addEventListener('scroll', onScroll, { passive: true });
                window.addEventListener('resize', onScroll);
                // Reserve room so the bar never covers the footer / lifts toasts above it.
                document.body.classList.add('has-sticky-atc');
                return () => {
                        window.removeEventListener('scroll', onScroll);
                        window.removeEventListener('resize', onScroll);
                        if (raf) cancelAnimationFrame(raf);
                        document.body.classList.remove('has-sticky-atc');
                };
        }, [targetRef]);

        return (
                <div
                        data-testid="pdp-sticky-atc"
                        aria-hidden={!show}
                        className={
                                'lg:hidden fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0A0A0A]/95 backdrop-blur-md px-4 py-3 ' +
                                'flex items-center gap-3 transition-transform duration-300 ' +
                                (show ? 'translate-y-0' : 'translate-y-full pointer-events-none')
                        }
                        style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
                >
                        <div className="min-w-0 flex-1">
                                <p data-testid="pdp-sticky-atc-price" className="font-mono text-[16px] text-white tabular-nums leading-tight">{priceStr || '—'}</p>
                                {variantTitle && variantTitle !== 'Default Title' && (
                                        <p data-testid="pdp-sticky-atc-variant" className="font-mono text-[10px] tracking-[0.14em] uppercase text-white/50 truncate">{variantTitle}</p>
                                )}
                        </div>
                        <button
                                type="button"
                                data-testid="pdp-sticky-atc-button"
                                onClick={onClick}
                                disabled={disabled}
                                className={
                                        'shrink-0 font-mono text-[11px] tracking-[0.18em] uppercase px-5 py-3.5 border transition-colors ' +
                                        (disabled && !busy
                                                ? 'border-white/15 text-white/40'
                                                : 'border-[#FF9F1C] bg-[#FF9F1C] text-[#0A0A0A] active:bg-transparent active:text-[#FF9F1C]')
                                }
                        >
                                {busy ? 'Adding…' : label}
                        </button>
                </div>
        );
}
